/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import "../../styles/info.css";
import "../../styles/timetable.css";

const ExpertiseInfoPanel = () => {
  const experiences = [
    {
      role: "Full-Stack Developer",
      company: "Enfold | ida",
      date: "2026 - Present",
      location: "Utrecht, NL",
      description:
        "Developing and maintaining websites and web applications according to clients needs. Using and adapting modern technologies and frameworks. Enhancing user experience and performance.",
    },
    {
      role: "Full-Stack Developer",
      company: "Getting the Market",
      date: "2022 - Nov. 2025",
      location: "Rotterdam, NL",
      description:
        "Developing and maintaining web applications using modern technologies like React, Node.js, MongoDB, SQL and WordPress. Leading a team of developers to deliver high-quality products. Developing websites and application according to clients needs.",
    },
    {
      role: "IT Engineer",
      company: "EF",
      date: "2020 - 2022",
      location: "Istanbul, TR",
      description:
        "Managing server and database, resolving software and hardware issues, planing system updates and backups, managing security systems, website and applications. Backend heavy tasks.",
    },
    {
      role: "IT and Dev. Traineeship",
      company: "epic",
      date: "2019 - 2020",
      location: "Colorado, US",
      description:
        "IT responsibilities within company, server and database management, technical support to other teams, Website/Application maintaining and development.",
    },
    {
      role: "Web Developer",
      company: "Freelance",
      date: "2017 - Present",
      location: "Rotterdam, NL",
      description:
        "Started my career as a freelance developer after graduation, working with React and custom Javascript solutions. Gained experience in full project lifecycle from design to deployment.",
    },
  ];

  return (
    <div className="info-panel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-file"> </i>
          experienceInfo.mrt
        </div>
      </div>
      <div className="info-content">
        <p className="info-entrance">// My journey through work life</p>
      </div>
      <div className="timeline-container">
        {experiences.map((exp, idx) => (
          <div key={idx} className="timeline-item">
            <div className="timeline-dot" />
            <div className="timeline-content">
              <h3 className="timeline-role">{exp.role}</h3>
              <p className="timeline-company">
                {exp.company} • {exp.date} • {exp.location}
              </p>
              <p className="timeline-description">{exp.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpertiseInfoPanel;
